/** Shared narrative insight kit — one source of truth for the cross-module insight experience. */
export { NarrativePanel, NarrativeCard, NarrativeCollapsible, NarrativeBeat, JargonTerm, rearmAdviserIntro } from './NarrativePanel.tsx';
export { InsightSection } from './InsightSection.tsx';
export { CashflowBridge } from './CashflowBridge.tsx';
export { FundingRunway } from './FundingRunway.tsx';
